export enum LeadCategory {
  SweepsImage = 'sweepsImage',
  TourEntryLeadForm = 'tourEntryLeadForm',
  InTourLeadImage = 'inTourLeadImage',
  TourContactForm = 'tourContactForm',
  AssertTouchForm = 'assertTouchForm',
}
